export const GET_OFFICE_SUCCESSFUL = "GET_OFFICE_SUCCESSFUL";

export const OFFICE_PROCESSING = "OFFICE_PROCESSING";

export const STOP_OFFICE_PROCESSING = "STOP_OFFICE_PROCESSING";
